// extracted by mini-css-extract-plugin
export default {"dots":"Dots_dots__iWeSr","dots4":"Dots_dots4__ID20U"};